'use client'
import { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import LinkComponent  from '@components/LinkComponent'
import LargeProjectCard from '@components/LargeProjectCard'

const ProjectCardSlider = ({ title, description, projectSlider, projects, url, cardStyle, dictionary, lang }) => {

  const [mounted, setMounted] = useState(false)
  useEffect(() => { setMounted(true) }, [])

  if (!mounted) {
    const maxSlides =
      projectSlider?.projectSlider?.desktop ||
      projectSlider?.projectSlider?.tablet  ||
      Math.ceil(projectSlider?.projectSlider?.mobile || 1.2) ||
      3
    const limited = projects.slice(0, maxSlides)
    return (
      <section className='carousel-wrapper lg:pl-0 pl-3'>
        {url ? (
          <LinkComponent href={url}>
            <h2 className='carousel-title-align'>{title?.[lang]}</h2>
          </LinkComponent>
        ) : (
          <h2 className='carousel-title-align'>{title?.[lang]}</h2>
        )}
        {description?.[lang]?.trim() && (
          <p className='carousel-description-align'>{description[lang]}</p>
        )}
        <div className="flex flex-row" style={{ gap: '16px' }}>
          {limited.map((project, i) => (
            <LargeProjectCard key={i} project={project} cardStyle={cardStyle} dictionary={dictionary?.card} lang={lang} />
          ))}
        </div>
      </section>
    )
  }

  return (
    <section className='carousel-wrapper w-full lg:pl-0 pl-3'>
      {url ? (
        <LinkComponent href={url}>
          <h2 className='carousel-title-align'>{title?.[lang]}</h2>
        </LinkComponent>
      ) : (
        <h2 className='carousel-title-align'>{title?.[lang]}</h2>
      )}
      {description?.[lang]?.trim() && (
        <p className='carousel-description-align'>{description[lang]}</p>
      )}
      <Swiper
        spaceBetween={16}
        navigation
        modules={[Navigation]}
        slidesPerView={projectSlider.projectSlider.mobile || 1.2}
        breakpoints={{
          768:  { slidesPerView: projectSlider.projectSlider.tablet  || 2 },
          1024: { slidesPerView: projectSlider.projectSlider.desktop || 3 },
        }}
      >
        {projects.map((project, i) => (
          <SwiperSlide key={i}>
            <LargeProjectCard project={project} cardStyle={cardStyle} dictionary={dictionary?.card} lang={lang} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default ProjectCardSlider